import React, { useState } from 'react';
import Grid from '../../../../muiComponents/Grid';
import {
    creditCardColumnGrid,
    EMPTY_CREDIT_CARD_EXPIRE_DATE,
    EMPTY_CREDIT_CARD_HOLDER_NAME,
    EMPTY_CREDIT_CARD_NUMBER,
} from '../../../../utils/bookings/bookingUtils';
import GridChild from '../../../../muiComponents/GridChild';
import front from '../../../../images/credit-card-front.svg';
import back from '../../../../images/credit-card-back.svg';
import Card from '../../../../muiComponents/Card';
import {
    CancellationPolicyState,
    CreditCardState,
} from '../../../../types/booking/BookingTypes';
import IconButton from '../../../../muiComponents/IconButton';
import { formatCreditCardExpireDate } from '../../../../utils/formatDates';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import MainSectionTitle from '../../yourProperties/Title';
import {
    formatCreditCardNumber,
    formatNumber,
    maskCreditCardNumber,
} from '../../../../utils/usefulFunctions';
import useTranslate from '../../../../customHooks/useTranslate';
import {
    gridSpacing20,
    gridSpacing30,
} from '../../../../utils/commonVariables/grid';
import Title from '../../../components/Title';

interface FinanceProps {
    paymentId: number;
    creditCard: CreditCardState;
    cancellationPolicies: CancellationPolicyState[];
    isCancelled: boolean;
    paymentAmount: number;
    paymentCurrency: string;
}

const Finance = (props: FinanceProps) => {
    const {
        creditCard,
        paymentId,
        cancellationPolicies,
        isCancelled,
        paymentAmount,
        paymentCurrency,
    } = props;
    const {
        creditCardNumber,
        creditCardExpiryDate,
        creditCardHolderName,
        cvc,
    } = creditCard;
    const cardNumberToPaint = creditCardNumber || EMPTY_CREDIT_CARD_NUMBER;
    const translate = useTranslate();

    const [isCardDataVisible, setIsCardDataVisible] = useState(false);

    const [isVisibleSection, setIsVisibleSection] = useState(true);

    return (
        <section className='booking__section'>
            <div
                className={`flex flex-between flex-align-baseline ${
                    !isVisibleSection ? 'border-color-bottom' : ''
                }`}
            >
                <MainSectionTitle text={translate('payment_info')} />
                <IconButton
                    iconName={isVisibleSection ? 'ExpandLess' : 'ExpandMore'}
                    onClick={() => setIsVisibleSection(!isVisibleSection)}
                />
            </div>
            {isVisibleSection ? (
                <>
                    {paymentId > 0 ? (
                        <Card className='booking__card padding20 flex-column gap-20'>
                            <>
                                <div className='flex flex-between flex-align-center gap-10 padding-inline15'>
                                    <SectionTitle
                                        title='Payment'
                                        className='text-capitalize text-secondary-700'
                                    />
                                    <IconButton
                                        iconName={
                                            isCardDataVisible
                                                ? 'VisibilityOff'
                                                : 'Visibility'
                                        }
                                        onClick={() =>
                                            setIsCardDataVisible(prev => !prev)
                                        }
                                    />
                                </div>
                                <Grid
                                    style={{ width: 'auto', margin: 0 }}
                                    columnSpacing={gridSpacing30}
                                    rowSpacing={gridSpacing20}
                                >
                                    {/* <CreditCard /> */}
                                    <GridChild gridProps={creditCardColumnGrid}>
                                        <div
                                            className='width100perc'
                                            style={{
                                                position: 'relative',
                                            }}
                                        >
                                            <p className='booking-credit-card__number'>
                                                {isCardDataVisible
                                                    ? formatCreditCardNumber(
                                                          cardNumberToPaint
                                                      )
                                                    : maskCreditCardNumber(
                                                          cardNumberToPaint
                                                      )}
                                            </p>

                                            {isCardDataVisible ? (
                                                <>
                                                    <p className='booking-credit-card__holder-name'>
                                                        {creditCardHolderName ||
                                                            EMPTY_CREDIT_CARD_HOLDER_NAME}
                                                    </p>
                                                    <p className='booking-credit-card__expire-date'>
                                                        {formatCreditCardExpireDate(
                                                            creditCardExpiryDate
                                                        ) ||
                                                            EMPTY_CREDIT_CARD_EXPIRE_DATE}
                                                    </p>
                                                </>
                                            ) : (
                                                ''
                                            )}
                                            <img
                                                className='width100perc'
                                                src={front}
                                            />
                                        </div>
                                    </GridChild>
                                    <GridChild gridProps={creditCardColumnGrid}>
                                        <div
                                            className='width100perc'
                                            style={{
                                                position: 'relative',
                                            }}
                                        >
                                            <p className='booking-credit-card__cvc'>
                                                {isCardDataVisible
                                                    ? cvc || 'XXX'
                                                    : '***'}
                                            </p>
                                            <img
                                                className='width100perc'
                                                src={back}
                                            />
                                        </div>
                                    </GridChild>
                                    {!isCancelled &&
                                        paymentAmount &&
                                        paymentCurrency && (
                                            <GridChild
                                                gridProps={creditCardColumnGrid}
                                            >
                                                <div className='flex-column'>
                                                    <Title className='text-capitalize text-secondary-600'>
                                                        {translate('total')}
                                                    </Title>
                                                    <p
                                                        className={`font-size-24 text-primary-400`}
                                                    >
                                                        {paymentCurrency &&
                                                        paymentAmount
                                                            ? formatNumber(
                                                                  paymentAmount,
                                                                  'currency',
                                                                  paymentCurrency
                                                              )
                                                            : formatNumber(
                                                                  paymentAmount,
                                                                  'decimal'
                                                              )}
                                                    </p>
                                                    <p className='font-size-12'>
                                                        {paymentCurrency ||
                                                            '---'}
                                                    </p>
                                                </div>
                                            </GridChild>
                                        )}
                                </Grid>
                            </>
                        </Card>
                    ) : (
                        ''
                    )}
                    {cancellationPolicies.length ? (
                        <Card className='booking__card padding35 flex-column gap-20'>
                            <SectionTitle
                                className='text-capitalize text-secondary-700'
                                title={translate('cancellation_policy')}
                            />
                            <div className='flex-column gap-5'>
                                {cancellationPolicies?.map(policy => {
                                    return (
                                        <p key={policy.id}>
                                            {policy.text || '----'}
                                        </p>
                                    );
                                })}
                            </div>
                        </Card>
                    ) : (
                        ''
                    )}
                </>
            ) : (
                ''
            )}
        </section>
    );
};

export default Finance;
